import { PICKUP_FILTERS } from '@/components/checkout/delivery-selector/pickup-filters/constants';
import { GtmEvents } from '@/gtm/gtm-events';

export class CartDeliveryGtmEvents extends GtmEvents {
  eventCategory = 'СобытияВКорзине';

  openModal() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_ПоказЭкрана',
    });
  }

  openCourierTab() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_ПоказЭкрана',
    });
  }

  changeCity() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Город_Изменить',
    });
  }

  cityChanged() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Город_Изменен',
    });
  }

  closeModal() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Закрыть',
    });
  }

  pointSelected({ filters, point } = {}) {
    const eventAction = {
      store: 'КРЗ_МСП_Выбран_Магазин',
      postamat: 'КРЗ_МСП_Выбран_Постамат',
      pvz: 'КРЗ_МСП_Выбран_ПВЗ',
      post: 'КРЗ_МСП_Выбран_ПочтаРФ',
    }[point.type];

    if (!eventAction) return;

    const activeFilters = Object.keys(filters).reduce((res, key) => {
      if (filters[key] && PICKUP_FILTERS[key]) res.push(PICKUP_FILTERS[key].label);
      return res;
    }, []).join(',');

    return this.gtmEvent({
      eventAction,
      eventLabel: `${activeFilters};${point.availableLinesCount}`,
    });
  }

  courierSelected() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Выбран_Курьер',
    });
  }

  courierTabAddressPredefined() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_АдресПредвыбран',
    });
  }

  courierTabAddressInteraction() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_БлокАдрес_Взаимодествие',
    });
  }

  courierTabAddressSave() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_БлокАдрес_Валиден',
    });
  }

  courierTabDateClick() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_Дата_Взаимодествие',
    });
  }

  courierTabTimeClick() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_Время_Взаимодествие',
    });
  }

  courierTabDateChange() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_Дата_Изменен',
    });
  }

  courierTabTimeChange() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_Время_Изменен',
    });
  }

  courierTabDateClickNA() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_Дата_Недоступен',
    });
  }

  courierTabTimeClickNA() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_Время_Недоступен',
    });
  }

  courierTabDeliveryNotAvailable() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_ДоставитьНеВозможно',
    });
  }

  courierTabCommentInteraction() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_Комментарий_Взаимодействие',
    });
  }

  courierTabAddressSaved() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_АдресСохранить',
    });
  }

  courierTabAddressNotSaved() {
    return this.gtmEvent({
      eventAction: 'КРЗ_МСП_Курьер_АдресНеСохранить',
    });
  }

  onClickSignInBtn() {
    return this.gtmEvent({
      eventAction: 'КРЗ_КонтактныеДанные_Войти',
    });
  }

  onClickSignUpBtn() {
    return this.gtmEvent({
      eventAction: 'КРЗ_КонтактныеДанные_Зарегистрироваться',
    });
  }

  onBlurFormField() {
    return this.gtmEvent({
      eventAction: 'КРЗ_КонтактныеДанные_Поля_Заполнение',
    });
  }

  onClickGetCodeBtn() {
    return this.gtmEvent({
      eventAction: 'КРЗ_КонтактныеДанные_ПолеТелефон_ПолучитьКод',
    });
  }

  onClickGetCodeAgainBtn() {
    return this.gtmEvent({
      eventAction: 'КРЗ_КонтактныеДанные_ПолеТелефон_ПолучитьКодПовторно',
    });
  }

  onClickConfirmPhoneBtn() {
    return this.gtmEvent({
      eventAction: 'КРЗ_КонтактныеДанные_ПолеТелефон_Подтвердить',
    });
  }

  onSuccessfullyConfirmedPhone() {
    return this.gtmEvent({
      eventAction: 'КРЗ_КонтактныеДанные_ПолеТелефон_Подтвержден',
    });
  }

  onActivatedSubscribe() {
    return this.gtmEvent({
      eventAction: 'КРЗ_КонтактныеДанные_ПолеEmail_Подписаться',
    });
  }

  onDeactivatedSubscribe() {
    return this.gtmEvent({
      eventAction: 'КРЗ_КонтактныеДанные_ПолеEmail_Отписаться',
    });
  }
}

export const cartDeliveryGtmEvents = new CartDeliveryGtmEvents();
